import { Checkbox } from "@/components/ui/checkbox";
import { TypographySmall } from "@/components/ui/typography";
import { useUpdateManyLineItems } from "@/queries/line-items/update";
import { useEffect, useState } from "react";
import {} from "react";

import { useInvoiceReviewContext } from "../ReviewProvider";

export const SetAccountConfidencesCheckbox = () => {
  const { invoiceReviewState } = useInvoiceReviewContext();
  const updateManyLineItems = useUpdateManyLineItems();
  const { invoiceData } = invoiceReviewState;

  const lineItemIds =
    invoiceData?.lineItems.map((item) => item.lineItemId) ?? [];

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (invoiceData?.lineItems.length === 0) {
      setChecked(false);
      return;
    }

    const accountConfidence = invoiceData?.lineItems.every(
      (item) => item.accountConfidence === 1,
    );

    setChecked(accountConfidence ?? false);
  }, [invoiceData?.lineItems]);

  const handleAccountConfidenceChange = async (checked: boolean) => {
    setChecked(checked);
    await updateManyLineItems(lineItemIds, {
      accountConfidence: checked ? 1 : 0,
    });
  };

  return (
    <>
      <div className="col-span-3">
        <TypographySmall>Account geprüft</TypographySmall>
      </div>
      <div className="col-span-9">
        <Checkbox
          disabled={invoiceData?.lineItems.length === 0}
          name="accountConfidence"
          checked={checked}
          onCheckedChange={handleAccountConfidenceChange}
        />
      </div>
    </>
  );
};
